// extracted by mini-css-extract-plugin
module.exports = {"xpacks":"xpacks___BKw6D","header":"header___3Ws90","title":"title___B4ujj","container":"container___15o4R"};